import { configureStore } from "@reduxjs/toolkit";
import chatReducer from './chatSlice';
import sidebarReducer from './sidebarSlice'
import chatBenchmarkingReducer from './chatSliceBenchmarking'


import authReducer from './authSlice'
export const store = configureStore({
    reducer:{
        chat:chatReducer,
        sidebar:sidebarReducer,
        chatBenchmarking:chatBenchmarkingReducer,
        auth:authReducer
    }
})

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch